import { WebsshLogin, getDomainFromUrl, useQuery } from '@monorepo/shared';
import './Webssh.less';
import { useCallback, useEffect, useRef, useState } from 'react';
import { on } from 'rsuite/esm/DOMHelper';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { Terminal } from '@xterm/xterm';
import { FitAddon } from '@xterm/addon-fit';

export const WebSSH = () => {
  let query = useQuery();
  const { state } = useLocation();
  const sid = query.get('sid') || state.sid;
  // const socketURL = 'wss://ca-west-3.fortisoar.test.forticloud.com/webssh';
  const terminalBoxRef = useRef<any>(null);
  const xtermRef = useRef<any>(null);
  const fitRef = useRef<any>(null);
  const socketRef = useRef<any>(null);
  const [data, setData] = useState<Record<string, any>>({});
  const [socketURL, setSocketURL] = useState<string>('');
  const [connectStatus, setConnectStatus] = useState<string>('idle');
  const [errorMessage, setErrorMessage] = useState<string>('');
  const { t } = useTranslation();
  useEffect(() => {
    if (sid) {
      const str = decodeURIComponent(sessionStorage.getItem(sid)!) || '';
      const obj = JSON.parse(str) || {};
      if (obj.account_id && obj?.region_url) {
        const url =
          'wss://' + getDomainFromUrl(obj?.region_url || '') + '/webssh';
        setData(obj);
        setSocketURL(url);
      }
    }
  }, [sid]);

  const onConnect = useCallback(
    (formValue: Record<string, any>) => {
      if (formValue.password && formValue.name) {
        if (socketRef.current) {
          socketRef.current.close();
        }
        const socket = new WebSocket(socketURL);
        socketRef.current = socket;
        setConnectStatus('connecting');
        socket.onopen = () => {
          if (xtermRef.current) {
            const term = xtermRef.current;
            term.reset();
            fitRef.current?.fit();
            term.focus();
            if (socket.readyState != WebSocket.CLOSED) {
              const message = {
                status: 0,
                type: 'login',
                data: {
                  account_id: data.account_id,
                  user_id: data.user_id,
                  access_from_user_id: data.access_from_user_id,
                  instance_id: data.instance_id,
                  group_id: data.group_id,
                  username: formValue.name,
                  password: formValue.password,
                  cols: term.cols,
                  rows: term.rows
                },
                token: data.token
              };
              socket.send(JSON.stringify(message));
            }
          }
        };

        socket.onmessage = (recv: any) => {
          if (xtermRef.current) {
            const term = xtermRef.current;
            const data = JSON.parse(recv.data);
            const message = data.message;
            const status = data.status;
            if (status === 0) {
              term.write(message);
              if (typeof message === 'string' && message.trim() === 'logout') {
                socket.close();
                setConnectStatus('logout');
                // setErrorMessage('You have successfully logged out!');
                setErrorMessage(`${t('common.webssh.logoutSuccess')}`);
              }
              if (
                typeof message === 'string' &&
                message.trim() ===
                  'passwd: all authentication tokens updated successfully.'
              ) {
                socket.close();
                setConnectStatus('logout');
                // setErrorMessage(
                //   'Password changed successfully, please login again!'
                // );
                setErrorMessage(`${t('common.webssh.passwordUpdated')}`);
              }
            }
            // connection successful
            else if (status === 2) {
              fitRef.current?.fit();
              setConnectStatus('connected');
            } else {
              socket.close();
              setConnectStatus('failed');
              setErrorMessage(message);
              term.write('\n\n\r' + message);
            }
          }
        };
      }
    },
    [data, socketURL, socketRef, xtermRef]
  );
  useEffect(() => {
    const resizeListener = on(window, 'resize', () => {
      fitRef.current.fit();
      if (
        xtermRef.current &&
        socketRef.current?.readyState !== WebSocket.CLOSED
      ) {
        const message = {
          status: 1,
          cols: xtermRef.current.cols,
          rows: xtermRef.current.rows
        };
        socketRef.current?.send(JSON.stringify(message));
      }
    });

    return () => {
      resizeListener.off();
    };
  }, []);

  useEffect(() => {
    if (terminalBoxRef.current && !xtermRef.current) {
      xtermRef.current = new Terminal({
        fontFamily: 'Fira Code, Iosevka, monospace',
        fontSize: 16,
        tabStopWidth: 4,
        cursorBlink: true
      });
      const fitAddon = new FitAddon();
      fitRef.current = fitAddon;
      xtermRef.current.loadAddon(fitAddon);
      xtermRef.current.open(terminalBoxRef.current);
      xtermRef.current.onRender(() => {
        fitAddon.fit();
      });
      xtermRef.current.onData((data: any) => {
        const message = {
          status: 0,
          type: 'client',
          data: data
        };
        var send_data = JSON.stringify(message);
        const socket = socketRef.current;
        if (socket && socket.readyState != WebSocket.CLOSED) {
          socket.send(send_data);
        }
      });
    }
  }, []);

  return (
    <div className="webssh-container">
      <div
        className="webssh-form-container"
        style={{
          display: connectStatus === 'connected' ? 'none' : 'flex'
        }}
      >
        {data?.account_id ? (
          <WebsshLogin
            onConnect={onConnect}
            status={connectStatus}
          ></WebsshLogin>
        ) : (
          <div style={{ display: 'grid', placeItems: 'center', color: '#333' }}>
            {' Fetch web SSH account info failed, please try again later!'}
          </div>
        )}
        <div className="webssh-error-message">{errorMessage}</div>
      </div>
      <div id="terminal" className="webssh-terminal" ref={terminalBoxRef}></div>
    </div>
  );
};
